export interface FocusKPI {
    metricId?: number;
    goal_Kpi?: string;
    actual?: number;
    target?: number;
    percentToTarget?: number;

    // for highlighting
    tracking_id?: number;
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const datesAreEqual = (a: Date, b: Date) =>
    a instanceof Date &&
    b instanceof Date &&
    a.setHours(0, 0, 0, 0) === b.setHours(0, 0, 0, 0);
